import React, { useState, useEffect, useRef } from 'react';
import './CollapseItem.style.css';
import moment from 'moment';
import { HtmlContent, Pre } from 'components';
import { Image } from 'antd';

const CollapseItem = ({
  title,
  content,
  answer,
  userName,
  answerName,
  create,
  update,
  status,
  secret,
  showContent = false,
  files,
}) => {
  console.log(status, '<< collapseitem status');
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [isOpen, setIsOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleToggleCollapse = () => {
    if (secret) {
      // TODO: 작성자 여부 확인
      window.alert('비밀글은 작성자만 볼 수 있습니다.');
    } else {
      if (!answer) return;
      else setIsOpen(!isOpen);
    }
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen]);

  /* ===== Render ===== */
  return (
    <div
      className="product_collapse_item"
      onClick={() => handleToggleCollapse()}
    >
      <div className="product_collapse_title">
        <ul>
          <li>{userName}</li>
          <li>{moment(create).format('YYYY.MM.DD')}</li>
        </ul>
        <div
          className="product_collapse_title_status"
          style={{
            color:
              status === 'DONE' ? 'var(--white-color)' : 'var(--black-color)',
            background:
              status === 'DONE' ? 'var(--black-color)' : 'var(--white-color)',
            border: '1px solid var(--black-color)',
          }}
        >
          {status === 'DONE' ? '답변완료' : '답변대기'}
        </div>
        <div className="product_collapse_title_text">
          <p>{secret ? '비밀글입니다.' : title}</p>
        </div>

        {!secret && showContent ? (
          <div
            className="product_collapse_title_text"
            style={{ padding: 24, background: '#EEEEEE' }}
          >
            <Pre style={{ fontSize: 14, lineHeight: '150%' }}>{content}</Pre>

            {files && files.length ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  marginTop: 24,
                }}
              >
                {files.map((file) => (
                  <Image src={file.file_url} width={150} height={150} preview />
                ))}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>

      {status === 'DONE' ? (
        <div
          ref={contentRef}
          className={`product_collapse_content ${isOpen ? 'open' : ''}`}
          style={{
            maxHeight: isOpen ? `${contentHeight}px` : 0,
          }}
        >
          <div className="product_collapse_content_container">
            <ul>
              <li>{answerName}</li>
              <li>{moment(update).format('YYYY.MM.DD')}</li>
            </ul>
            <HtmlContent content={answer} />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CollapseItem;
